import { useFormikContext } from 'formik';
import React, { FC } from 'react';
import { TYPE_ENTRY_ONLY } from "../../../../constants/install-device";
import { useLocale } from '../../../../contexts/localeContext';
import { TranslationKeys } from '../../../../contexts/TranslationKeys';
import { WizardSummaryField, WizardSummaryLayout, WizardSummarySection } from '../../../wizard/wizard-summary-layout';

interface SummaryProps {
    onBack: (e) => void;
}

const Summary: FC<SummaryProps> = ({ onBack }) => {
    const { translate } = useLocale();
    const { values } = useFormikContext<any>();

    return (
        <WizardSummaryLayout onBack={onBack} submitLabel={translate.byKey(TranslationKeys.execute)}>
            <WizardSummarySection heading={translate.byKey(TranslationKeys.selectedDevice)}>
                <WizardSummaryField label={translate.byKey(TranslationKeys.name)} value={values.name} />
                <WizardSummaryField label={translate.byKey(TranslationKeys.fixedAddress)} value={values.fixedAddress} />
                <WizardSummaryField label={translate.byKey(TranslationKeys.ipAddress)} value={values.ipAddress} />
            </WizardSummarySection>

            <WizardSummarySection heading={translate.byKey(TranslationKeys.selectedPeripherals)}>
                <div className="flex flex-col break-words p-1">
                    <span className="text-sm text-black">
                        {values.selectedPeripherals.length > 0
                            ? values.selectedPeripherals.toString()
                            : translate.byKey(TranslationKeys.autoInstallPeripherals)}
                    </span>
                </div>
            </WizardSummarySection>

            <WizardSummarySection heading={translate.byKey(TranslationKeys.selectedIpDevices)}>
                <div className="flex flex-col break-words p-1">
                    <span className="text-sm text-black">
                        {values.selectIPDevices.length > 0
                            ? values.selectIPDevices.toString()
                            : translate.byKey(TranslationKeys.none)}
                    </span>
                </div>
            </WizardSummarySection>

            {values.autoCreateDoors && (
                <WizardSummarySection heading={translate.byKey(TranslationKeys.doorCreation)}>
                    <WizardSummaryField
                        label={translate.byKey(TranslationKeys.autoCreateDoors)}
                        value={values.autoCreateDoorsType === TYPE_ENTRY_ONLY
                            ? translate.byKey(TranslationKeys.entryReaderOnly)
                            : translate.byKey(TranslationKeys.exitAndEntryReaders)}
                    />
                </WizardSummarySection>
            )}
        </WizardSummaryLayout>
    );
}

export default Summary;
